// extracted by mini-css-extract-plugin
export default {"profileCard":"ProfileCard_profileCard__r6Thv","cardContent":"ProfileCard_cardContent__Ymuff"};